import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import MediaBorders from 'constants/media-borders';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import i18n from 'i18n';

// 画像ファイルのインポート
import flow1PC1x from 'assets/images/PC/@1x/img_flow1.png';
import flow1PC2x from 'assets/images/PC/@2x/img_flow1@2x.png';
import flow1SP2x from 'assets/images/SP/@2x/img_flow1@2x.png';
import flow1SP3x from 'assets/images/SP/@3x/img_flow1@3x.png';

import flow2PC1x from 'assets/images/PC/@1x/img_flow2.png';
import flow2PC2x from 'assets/images/PC/@2x/img_flow2@2x.png';
import flow2SP2x from 'assets/images/SP/@2x/img_flow2@2x.png';
import flow2SP3x from 'assets/images/SP/@3x/img_flow2@3x.png';

import flow3PC1x from 'assets/images/PC/@1x/img_flow3.png';
import flow3PC2x from 'assets/images/PC/@2x/img_flow3@2x.png';
import flow3SP2x from 'assets/images/SP/@2x/img_flow3@2x.png';
import flow3SP3x from 'assets/images/SP/@3x/img_flow3@3x.png';

import flow4PC1x from 'assets/images/PC/@1x/img_flow4.png';
import flow4PC2x from 'assets/images/PC/@2x/img_flow4@2x.png';
import flow4SP2x from 'assets/images/SP/@2x/img_flow4@2x.png';
import flow4SP3x from 'assets/images/SP/@3x/img_flow4@3x.png';

const headerData = {
  '/order-aggregators/purchase': {
    title: i18n.t('orderAggregators:purchase:header.title'),
    pc: {
      '1x': flow1PC1x,
      '2x': flow1PC2x
    },
    sp: {
      '2x': flow1SP2x,
      '3x': flow1SP3x
    },
    alt: i18n.t('orderAggregators:purchase:header.alt')
  },
  '/order-aggregators/payment': {
    title: i18n.t('orderAggregators:payment:header.title'),
    pc: {
      '1x': flow2PC1x,
      '2x': flow2PC2x
    },
    sp: {
      '2x': flow2SP2x,
      '3x': flow2SP3x
    },
    alt: i18n.t('orderAggregators:payment:header.alt')
  },
  '/order-aggregators/confirmation': {
    title: i18n.t('orderAggregators:confirmation:header.title'),
    pc: {
      '1x': flow3PC1x,
      '2x': flow3PC2x
    },
    sp: {
      '2x': flow3SP2x,
      '3x': flow3SP3x
    },
    alt: i18n.t('orderAggregators:confirmation:header.alt')
  },
  '/order-aggregators/completion': {
    title: i18n.t('orderAggregators:completion:header.title'),
    pc: {
      '1x': flow4PC1x,
      '2x': flow4PC2x
    },
    sp: {
      '2x': flow4SP2x,
      '3x': flow4SP3x
    },
    alt: i18n.t('orderAggregators:completion:header.alt')
  }
};

const FlowImage = ({ path }) => (
  <picture>
    <source
      media={`(min-width: ${MediaBorders.umedium})`}
      srcSet={`
        ${headerData[path]['pc']['1x']} 1x,
        ${headerData[path]['pc']['2x']} 2x
      `}
    />
    <source
      srcSet={`
        ${headerData[path]['sp']['2x']} 2x,
        ${headerData[path]['sp']['3x']} 3x
      `}
    />
    <img src={headerData[path]['pc']['1x']} alt={headerData[path]['alt']} />
  </picture>
);

const OrderAggregatorsHeader = ({ className, path }) => (
  <div className={className}>
    <h2>{headerData[path].title}</h2>
    <FlowImage path={path} />
  </div>
);

const commonStyle = css`
  width: 100%;
  text-align: center;
  background-color: ${Colors.gray4};

  h2 {
    ${FontStyles.text13};

    color: ${Colors.black1};
    margin: 0;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  height: 260px;
  padding-top: 72px;
  margin-top: 104px;

  h2 {
    font-size: 32px;
    margin-bottom: 48px;
  };
`;

const spStyle = CustomMedia.lessThan('medium')`
  height: 122px;
  padding-top: 24px;

  h2 {
    font-size: 22px;
    margin-bottom: 12px;
  };
`;

export default applyStyles(OrderAggregatorsHeader)(
  commonStyle,
  pcStyle,
  spStyle
);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/Header.js